import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import measurePropType from '../propTypes/measurePropType';
import TruncatedText from 'common/components/TruncatedText';

import './measure-title.scss';
import { getMeasureCardTitle } from '../lib/measureHelpers';

// Just a measure title. Single line display, 100% width, ellipsis truncation. Intended to be used in
// MeasureResultCard and MeasureChart.
export class MeasureTitle extends Component {
  static propTypes = {
    measure: measurePropType,
    lens: PropTypes.shape({
      name: PropTypes.string
    })
  };

  render() {
    const { lens, measure } = this.props;
    const title = getMeasureCardTitle(measure, lens);

    return (
      <div className="measure-title" title={title}>
        <div>
          <TruncatedText lines={2} text={title} />
        </div>
      </div>
    );
  }
}

export default MeasureTitle;
